import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Utils from '../_shared/utils';
import * as _moment from 'moment';
import { Moment } from 'moment';
const moment = _moment;

@Component({
    selector: 'app-reservation-invoice',
    templateUrl: './reservation-invoice.component.html',
    styleUrls: ['./reservation-invoice.component.scss'],
    standalone: false
})
export class ReservationInvoiceComponent implements OnInit {
	
	@Input() quote: any = {};
	@Input() reservation: any;
	@Input() isValidReservation: boolean;
	@Input() showShortInvoiceDetail: boolean;
	@Output() updateQuote = new EventEmitter<any>();

  constructor() {
   }

  ngOnInit(): void {
  }

  formatCurrency(num: any) {
		return Utils.formatCurrency(num);
	}
	
	calculateDiscount(price: any, percentage: any){
		return Utils.calculateDiscount(price, percentage);
	}

	showCouponDialog(){
		this.updateQuote.emit("");
	}
}
